"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdatetime_1 = require("./fdatetime");
/**
 * aktualna data i czas w formacie yyyy-MM-dd HH:mm:ss
 */
function now() {
    return fdatetime_1.default(new Date());
}
exports.default = now;
//# sourceMappingURL=now.js.map